<template>
   <b-container>
     <h4 >Cluster Teams</h4>
     <b-row>
         <b-col>
            Teams

        <b-col  class="my-1">
        <b-form-group
          label="Filter"
          label-for="filter-input"
          label-cols-sm="1"
          label-size="sm"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="search"
              placeholder="Type to Search"
            ></b-form-input>

            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
             <b-table
                v-cloak
                responsive
                :fields="fields"
                :items="teams"
                :striped="true"
                :bordered="true"
                :hover="true"
                stacked="md"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                @filtered="onFiltered"
                >
                <template slot="cell(team_name)" slot-scope="row">
                    <b-link
                    @click.stop="stopClick"
                    :to="{ name: 'EditTeam', params: { id: row.item.uuid } }"
                    >{{ row.item.team_name }}</b-link
                    >
                    <br />
                    <!-- <p class="small-date">country: {{ row.item.country }}</p>
                    <p class="small-date">district: {{ row.item.region }}</p> -->
                </template>
                 <template slot="cell(district)" slot-scope="row">
                   
                    <br />
                    <!-- <p class="small-date">country: {{ row.item.country }}</p> -->
                    <p class="small-date"> {{ row.item.district }}</p>
                </template>
                <template slot="cell(country)" slot-scope="row">
                   
                    <br />
                    <!-- <p class="small-date">country: {{ row.item.country }}</p> -->
                    <p class="small-date"> {{ row.item.country }}</p>
                </template>
                <template slot="cell(uuid)" slot-scope="row">
                    <b-link v-if="!isEdit" class="add" @click.stop="addTeam(row.item)">ADD</b-link>
                    <b-link v-else class="add" @click.stop="addLink(row.item)">ADD</b-link>
                </template>
                </b-table>
                <b-row>
                <b-col md="6" class="my-1">
                    <b-pagination
                    :total-rows="teams.length || 0"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-0"
                    />
                </b-col>
                </b-row>
         </b-col>
         <b-col>
             Added Teams

               <b-col  class="my-1">
        <b-form-group
          label="Filter"
          label-for="filter-input"
          label-cols-sm="1"
          label-size="sm"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filter-input"
              v-model="clusterFilter"
              type="search"
              placeholder="Type to Search"
            ></b-form-input>

            <b-input-group-append>
              <b-button :disabled="!clusterFilter" @click="clusterFilter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
             <b-table
                v-cloak
                responsive
                :fields="fields"
                :items="clusterTeams"
                :striped="true"
                :bordered="true"
                :hover="true"
                stacked="md"
                :current-page="clusterPage"
                :per-page="perPage"
                :filter="clusterFilter"
                @filtered="clusterOnFiltered"
                >
                <template slot="cell(team_name)" slot-scope="row">
                    <b-link
                    @click.stop="stopClick"
                    :to="{ name: 'EditTeam', params: { id: row.item.uuid } }"
                    >{{ row.item.team_name }}</b-link
                    >
                    <br />
                    <!-- <p class="small-date">country: {{ row.item.country }}</p>
                    <p class="small-date">district: {{ row.item.region }}</p> -->
                </template>
                 <template slot="cell(district)" slot-scope="row">
                   
                    <br />
                    <!-- <p class="small-date">country: {{ row.item.country }}</p> -->
                    <p class="small-date"> {{ row.item.district }}</p>
                </template>
                <template slot="cell(country)" slot-scope="row">
                   
                    <br />
                    <!-- <p class="small-date">country: {{ row.item.country }}</p> -->
                    <p class="small-date"> {{ row.item.country }}</p>
                </template>
                <template slot="cell(uuid)" slot-scope="row">
                    <b-link v-if="!isEdit" class="add" @click.stop="removeTeam(row.item)">Delete</b-link>
                    <b-link v-else class="add" @click.stop="deleteLink(row.item)">Delete</b-link>
                </template>
                </b-table>
                <b-row>
                <b-col md="6" class="my-1">
                    <b-pagination
                    :total-rows="teams.length || 0"
                    :per-page="perPage"
                    v-model="clusterPage"
                    class="my-0"
                    />
                </b-col>
                </b-row>
         </b-col>
     </b-row>
   </b-container>
</template>
<script>

import { mapActions, mapGetters } from "vuex";
import TeamService from "@/services/TeamService";
import ClusterService from "@/services/ClusterService";
import router from "@/router";
export default {
  name: 'ClusterTeams',
  data(){
      return{
        fields: [
            { key: "team_name", label: "Name", sortable: true },
            { key: "district", label: "District", sortable: true },
            { key: "country", label: "Country", sortable: true },
            { key: "uuid", label: "Action" },
        ],
        clusterTeams:[],
        clusterIds:[],
        currentPage: 1,
        perPage: 5,
        clusterPage:1,
        filteredResults: null,
        filter: null,
        clusterFilter: null,
        teams:[],
        isEdit:false,
        user_uuid:""
      }
  },
  methods:{
     ...mapActions({
        REMOVE_TEAM_ID: "cluster/REMOVE_TEAM_ID",
        ADD_TEAM_ID: "cluster/ADD_TEAM_ID",
      }),
      stopClick() {},
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
        },
      clusterOnFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
        },
      addTeam(val){
          this.clusterTeams.push({uuid:val.uuid,team_name:val.team_name,district:val.district,country:val.country});
          this.clusterIds.push(val.uuid);
          this.ADD_TEAM_ID(val.uuid);
          this.teams.forEach((element,index) => {
            if(element.uuid == val.uuid){
              this.teams.splice(index,1);
            }
          });
      },
      removeTeam(val){
          var itemIndex;
         // var index = this.clusterIds.findIndex(e=> e.uuid === val.uuid);
          this.clusterIds.forEach((element,index) => {
            if(element == val.uuid){
              itemIndex = index;
            }
          });
         
          this.REMOVE_TEAM_ID(val.uuid);
          this.teams.push(val);
          this.clusterIds.splice(itemIndex,1);
          this.clusterTeams.splice(itemIndex,1);

         console.log(itemIndex);
      },
      getTeams(){
            TeamService.fetchTeams().
              then((data)=>{
                 var teamTemp = data.data.results;
                 teamTemp.forEach(element => {
                   if(element.active){
                    this.teams.push({team_name:element.team_name,district:element.district,country:element.country,uuid:element.uuid});
                   }
                 });
              }).
              catch((err) => console.error(err));
      },
      getClusterTeams(){
        const id = router.currentRoute.params.id;
        if(id != null){
          this.isEdit = true;
          this.user_uuid = id;
            TeamService.fetchClusterTeams(id).
              then((data)=>{
                 var teamTemp = data.data.results;
                 console.log(teamTemp);
                 teamTemp.forEach(element => {
                   if(element.active){
                    this.clusterTeams.push({team_name:element.team_name,district:element.district,country:element.country,uuid:element.uuid,clusterId:element.clusterid});
                   }
                 });
              }).
              catch((err) => console.error(err));
        }

        // const deleteItems = new Set(this.clusterTeams);
        // const newItems = this.teams.filter((e)=>{
        //   return !deleteItems.has(e.uuid)
        // })
        var teamTmp = this.teams;
        console.log("cons"+teamTmp);
        teamTmp = teamTmp.filter(ar => !teamTmp.find(rm => (rm.uuid === ar.uuid ) ))
        console.log(teamTmp);
       // console.log(this.newItems);
      },
    async addLink(val){
       var tmpTeam = [];
       tmpTeam.push(val.uuid);
       var tmp = {src_id:this.user_uuid,teams:tmpTeam}
      // console.log(tmp);
      await ClusterService.addCluster(tmp);
      location.reload();
    },   
    async deleteLink(val){
       var tmp = {id:val.clusterId,user_uuid:this.user_uuid,team_uuid:val.uuid,active:false}
      // console.log(tmp);
      await ClusterService.deleteCluster(tmp.id);
      location.reload();
    },  
    test(){
      var myArray = [
        {name: 'deepak', place: 'bangalore'}, 
        {name: 'chirag', place: 'bangalore'}, 
        {name: 'alok', place: 'berhampur'}, 
        {name: 'chandan', place: 'mumbai'}
      ];
      var toRemove = [
        {name: 'deepak', place: 'bangalore'},
        {name: 'alok', place: 'berhampur'}
      ];



      myArray = myArray.filter(ar => !toRemove.find(rm => (rm.name === ar.name && ar.place === rm.place) ))
     // console.log(myArray);
    }      
  },
  async created() {
     await this.getTeams();
     await this.getClusterTeams();
     this.test();
  },
};
</script>